import { CondensedSearchInput } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/CondensedSearchInput/CondensedSearchInput";

export { CondensedSearchInput };
